export const IMPLEMENTED_LANGUAGES = [
    "ru",
    "tt",
    "cv",
    "ba",
    "kv",
    "be",
    "kk",
    "ky",
    "tg",
    "uz",
    "hy",
    "az",
    "ka",
    "ab",
    "mo",
    "ro",
    "tk"
];

export const DEFAULT_SORTING_PAYMENT_METHODS = [1, 2, 3, 4, 5];
